import tw from "twin.macro"
import React from "react"
import ContextualImage from "./contextualImage"

interface ContextualProps {
  contextual_image_url: Array<string>
  contextual_caption?: Array<string>
  record_id: string
}

const ContextualImages = (props: ContextualProps) => {
  const { contextual_image_url, contextual_caption } = props

  return (
    <>
      <div tw="py-4 w-mobile text-center text-sm font-sans border-b border-rpd-gray-2">Additional Images</div>

      <div tw="space-y-10">
        <ul tw="flex justify-center flex-wrap items-center space-x-4 w-full px-2 tablet:(px-0)">
          {contextual_image_url.map((imageUrl: string, i: number) => {
            if (imageUrl) {
              const caption = contextual_caption && contextual_caption[`${i}`]
              return (
                <li key={i}>
                  <ContextualImage imageUrl={imageUrl} caption={caption} />
                </li>
              )
            }
            return <></>
          })}
        </ul>
      </div>
    </>
  )
}

export default ContextualImages
